import { Theme } from '@mui/material'
import { makeStyles } from '@mui/styles'

export const useStyles = makeStyles<Theme>(theme => ({
    informationBoxHeaderText: {
        marginBottom: 5,
        color: theme.color.text.main,
        textAlign: 'center',
        fontSize: 24,
        fontWeight: 600,

        [theme.breakpoints.down('sm')]: {
            fontSize: 20,
        },
    },
    informationBoxText: {
        color: theme.color.text.secondary,
        textAlign: 'center',
        fontSize: 16,
        lineHeight: '20px',

        '& .button': {
            color: theme.color.text.active,
            fontWeight: 600,
            cursor: 'pointer',

            [theme.breakpoints.down('sm')]: {
                display: 'none',
            },
        },
    },
    verifyAccountButton: {
        '&.verifyAccountButton': {
            display: 'block',
            margin: '10px auto 0',
            padding: '15px 30px',
            width: 'max-content',
        },
    },
    recentTransactions: {
        marginTop: 35,
        '& .drop-down-title': {
            fontSize: 20,
        },
    },
    buttonOutlined: {
        backgroundColor: '#FFF',
        marginLeft: 15,
        opacity: 0.5,
        color: '#222 !important',
        textTransform: 'none',

        [theme.breakpoints.down('sm')]: {
            margin: 0,
            padding: '10px 15px !important',
        },
    },
    noTransactionContainer: {
        backgroundColor: '#FFFFFF',
        minHeight: 100,
        width: '100%',
        height: '100%',
        padding: 30,
        display: 'flex',
        flexDirection: 'column',
        lineHeight: '20px',
        borderRadius: theme.variables.paper.borderRadius,

        [theme.breakpoints.down('sm')]: {
            padding: 15,
        },
    },
    transactionIconContainer: {
        backgroundColor: '#F6F6F6',
        width: 60,
        height: 60,
        margin: '0 auto 10px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        borderRadius: '50%',

        '& .icon': {
            width: 33,
            height: 33,
        },
    },
}))
